const zhCN = {
  // Navigation
  nav_plan: '计划',
  nav_itinerary: '行程',
  nav_saved: '已保存',

  // Header
  explore_photos: '探索照片',
  sign_in: '登录',

  // Plan screen
  new_trip: '+ 新行程',
  add_city_header: '添加城市',
  city_placeholder: '输入城市名称…',
  add_cities_empty: '添加城市以开始规划行程',
  dest_bangkok: '曼谷', dest_paris: '巴黎', dest_london: '伦敦', dest_dubai: '迪拜',
  dest_singapore: '新加坡', dest_tokyo: '东京', dest_new_york: '纽约',
  dest_istanbul: '伊斯坦布尔', dest_kuala_lumpur: '吉隆坡', dest_seoul: '首尔',
  hero_badge: 'AI 智能行程规划',
  hero_title_line1: '您的下次旅程，',
  hero_title_line2: '完美规划。',
  hero_subtitle: '点选目的地，即刻开始规划',
  most_visited_label: '最受欢迎目的地',
  popular_destinations: '热门目的地',
  or_type_your_own: '或自行输入城市',
  where_going_label: '您要去哪里？',
  expanding_region: (r) => `正在查找 ${r} 的热门城市…`,
  tap_to_explore: '— 点击探索',
  attraction_count: (n) => `${n} 个景点`,
  show_less: '收起',
  read_more: '阅读更多',
  more: '更多',
  less: '收起',
  no_attractions: '尚未添加景点',
  add_attraction_placeholder: (city) => `在 ${city} 添加景点…`,
  auto_add_title: '自动添加推荐景点',
  preferences_label: '兴趣',
  all_types_label: '全部类型',
  edit_interests: '编辑兴趣…',
  plan_framing_msg: '保留您喜欢的，移除其余的，然后生成每日计划。',
  add_back: '恢复',
  added_label: '已添加',
  refresh_attractions: '刷新景点',
  plan_multi_summary: (n, m) => `${n} 个城市 · ${m} 个景点`,
  filter_onboarding_msg: '个性化您的景点',
  filter_onboarding_sub: '点击类型来聚焦 — 我们将重新生成匹配的建议。',
  explore_nearby: '探索附近景点',
  explore_nearby_sub: '浏览行程中必看景点的照片',
  finding_attractions: '正在寻找景点…',
  finding_attractions_1: '正在询问 AI 推荐…',
  finding_attractions_2: '寻找必游景点…',
  finding_attractions_3: '即将完成…',
  generating_msg_1: '规划您的行程天数…',
  generating_msg_2: '寻找最佳景点…',
  generating_msg_3: '制作您的旅游行程…',
  view_itinerary: '查看行程',
  generate_itinerary: '生成行程',
  filterLabel: (label) => ({ 'All': '全部', 'Culture': '文化', 'Nature': '自然', 'Entertainment': '娱乐', 'Shopping': '购物', 'Food & Drink': '餐饮', 'Kids': '亲子', 'Seniors': '乐龄' })[label] ?? label,

  // Itinerary screen
  rename: '重命名',
  days: (n) => `${n} 天`,
  unsaved_dot: '未保存的更改',
  share_itinerary: '分享行程',
  copy: '复制',
  copied: '已复制！',
  add_more_attractions: '添加更多景点',
  search_city_placeholder: '搜索城市…',
  plus_city: '+ 城市',
  your_cities: '您的城市',
  unscheduled_count: (n) => `未安排的景点（${n}）`,
  drag_to_schedule: '拖拽到某天进行安排',
  loading_details: '正在加载详情…',
  drag_here: '将景点拖到此处',
  day_label: (n) => `第 ${n} 天`,
  activity_count: (n) => `${n} 个活动`,
  add_note: '+ 添加备注',
  note_placeholder: '这天的备注 — 酒店信息、午餐地点、提醒事项…',
  save_note: '保存备注',
  cancel: '取消',
  continue_in_city: '继续在现有城市',
  change_back: '← 更改',
  save: '保存',
  hotel_nights_label: '晚数',
  hotel_name_label: '酒店名称',
  restaurant_label: '餐厅（可选）',
  search_hotel: '搜索酒店…',
  search_restaurant: '搜索餐厅…',
  searching: '搜索中…',
  address_label: '地址',
  time_label: '时间',
  duration_label: '时长',
  notes_label: '备注',
  time_placeholder: '例如：上午 9:00',
  duration_placeholder: '例如：2 小时',
  notes_placeholder: '例如：下午 3 点办理入住、泳池景观房…',
  drag_to_reorder: '拖拽以重新排序',
  details: '详细信息',
  edit: '编辑',
  snip: 'Snip',
  remove: '移除',
  move_to_day_picker: '移至第…天',
  trip_start_date: '出发日期',
  itinerary_photo_sub: '根据您的城市，AI 智能推荐',
  itinerary_photo_cta: '探索旅途中的隐藏宝藏',
  hotel: '酒店',
  meal_at: (restaurant) => `在 ${restaurant}`,
  add_day: '添加天数',
  save_changes: '保存更改',
  saved_check: '已保存 ✓',
  save_itinerary: '保存行程',
  print_export: '🖨️ 打印 / 导出 PDF',
  photos_details: '照片与详情',

  // Saved screen
  snip_requires_account: '创建免费账号以保存书签',
  sign_in_to_save:'登录以保存和查看您的行程',
  sign_in_or_create: '登录或创建账户',
  snips: 'Snips',
  place_count: (n) => `${n} 个地点`,
  trips: '行程',
  loading_trips: '正在加载行程…',
  no_saved_trips: '暂无已保存的行程',
  add_to_plan: '加入计划',
  add_to_itinerary_btn: '加入行程',
  untitled_trip: '未命名行程',
  open: '打开',

  // User menu
  signed_in_as: '已登录为',
  change_password: '更改密码',
  delete_user_menu: '删除用户',
  sign_out: '退出登录',

  // Load saved trip confirmation
  load_trip_confirm_title: '打开已保存的行程？',
  load_trip_confirm_msg: '您当前的计划将被丢弃。如需保留，请先保存。',

  // New trip confirmation
  unsaved_changes_title: '未保存的更改',
  unsaved_changes_msg: '您当前的行程有未保存的更改。仍要开始新行程吗？',
  discard_start_new: '放弃并新建',
  new_trip_tab_title: '开始新行程？',
  new_trip_tab_msg: '您当前的行程将被清除。如需保留，请先保存。',
  start_fresh: '重新开始',

  // Auth modal
  create_account: '创建账户',
  email_placeholder: '电子邮箱',
  password_placeholder: '密码',
  i_agree_to: '我同意',
  terms_of_service: '服务条款',
  privacy_policy: '隐私政策',
  and: '和',
  no_account: '还没有账户？ ',
  have_account: '已有账户？ ',
  network_error: '网络错误，请重试',
  err_email_exists: '此电子邮件已有账户',
  err_invalid_credentials: '邮箱或密码无效',
  err_email_password_required: '电子邮件和密码为必填项',
  err_password_too_short: '密码至少需要 6 个字符',

  // Change password modal
  select_user: '选择用户…',
  new_password_placeholder: '新密码（至少 6 个字符）',
  update_password: '更新密码',
  password_updated: '密码已更新',
  select_a_user: '请选择用户',
  network_error_short: '网络错误',

  // Delete user modal
  delete_user_trips: '删除用户和行程',
  deleted_user: (email) => `已删除 ${email}`,

  // Photo mode
  photo_loading_msg_1: '正在为您寻找精彩景点…',
  photo_loading_msg_2: '正在确认照片与详情…',
  photo_loading_msg_3: '即将完成…',
  finding_places: '正在为您寻找地点…',
  could_not_load_places: '无法加载地点',
  no_places: '没有可显示的地点',
  ai_error: '连接 AI 时出现问题，请稍后再试。',
  add_cities_suggestions: '添加城市或保存地点以获取个性化建议。',
  retry: '重试',
  close: '关闭',
  finding_more_places: '正在寻找更多地点…',
  seen_it_all: '您已看完所有地点！',
  photo_limit_msg: '您已达到本次会话 50 个地点的上限。',
  check_snips: '查看您的 Snips 以回顾已保存的地点',
  photo_unavailable: '照片不可用',
  loading: '加载中…',
  skip: '跳过',
  plus_itinerary: '+ 行程',
  plus_plan: '+ 计划',
  photo_explore_title: '照片探索',
  photo_explore_sub: '以视觉方式发现地点',
  swipe_lr: '左右滑动跳过',
  swipe_up: '向上滑动跳过',
  lets_go: '出发！',
  tutorial_skip_desc: '跳过此地点',
  tutorial_snip_desc: '保存到 Snips 收藏，稍后查看',
  tutorial_add_plan_desc: '添加到计划标签页',
  tutorial_add_itinerary_desc: '直接添加到当前行程',
  tutorial_swipe_hint: '也可以向左、右或向上滑动跳过',

  // Footer
  copyright: '© 2026 Pazzie Inc.',
  terms: '条款',
  privacy: '隐私',
  sample_itineraries: '示例行程',
  browse_all_itineraries: '浏览全部 →',

  // Legal overlay
  back_to_app: '← 返回 SnipTrip',

  // Error boundary
  something_wrong: '出现错误',
  reload: '重新加载',

  // Print view
  copy_text: '复制文字',
  copied_check: '✓ 已复制',

  // Logic / computed strings
  copy_of: (name) => `${name} 的副本`,
  transportation: '交通',
  meal: '餐食',

  // Chat mode
  chat_mode_link: '或使用 AI 对话规划',
  chat_back: '← 返回构建模式',
  chat_input_placeholder: '发送消息…',
  chat_error: '出现错误，请重试。',
  chat_cities_count: (n) => `${n} 个城市`,
  chat_places_count: (n) => `${n} 个景点`,
  chat_no_cities: '尚未添加城市',

  // Discovery panels
  thinking_where: '正在思考带您去哪里…',
  couldnt_load_suggestions: '无法加载建议。再试一次？',
  back: '← 返回',
  no_new_suggestions: '暂无新建议 — 请尝试其他问题。',
  back_to_questions: '← 返回问题',
  dismiss: '关闭',
  where_to_next_header: '接下来去哪？',
  describe_place: '描述地点类型…',
  go: '前往',
  finding_ideas: '寻找灵感中…',
  more_attractions: '更多景点…',
  different_angle: '或从不同角度探索：',
  mood_for: '您现在想做什么？',
  back_questions_short: '← 问题',
  describe_looking_for: '描述您在寻找什么…',
  where_to_next_trigger: (city) => city ? `+ 离开${city}后去哪里？` : '+ 接下来去哪？',
  what_else_trigger: (city) => `+ 在${city}附近还应该加什么？`,
  day_chip_add_attraction: '添加景点',
  day_chip_add_city: '添加附近城市',
  auto_populate_prompt: (city) => `自动推荐${city}的热门景点？`,
  auto_populate_yes: '是，推荐一些',
  auto_populate_no: '不，我自己添加',
  or_discover_new: '+ 或探索新地方',
  select: '选择',
  add: '添加',
  freeform_cta: '其他 — 我来描述',
};

export default zhCN;
